import {
  GuestActionType,
  GuestPostPurchaseChoice,
  type GuestCheckout,
  type GuestCheckoutActionToken,
} from "@prisma/client";

export { GuestActionType, GuestPostPurchaseChoice };

export type GuestCheckoutType = GuestCheckout;

export type GuestCheckoutActionTokenType = GuestCheckoutActionToken;

export interface AuthGuestDto {
  email: string;
  // Optional: the Group unlock authenticates with the email alone.
  firstName?: string | null;
  lastName?: string | null;
  // Group unlock intent: the event whose organiser's Groups decide the outcome. When it is
  // present, the authentication is atomic and leaves nothing behind if no Group matches.
  groupUnlockEventId?: string | null;
}

export type AuthGuestResponseDto =
  | {
      // The email belongs to no Group of the event's organiser: nothing was persisted.
      noGroupFound: true;
    }
  | {
      noGroupFound?: false;
      userId: string;
      // The guest session token, usable as a Bearer token where the cookie cannot be sent (embed).
      accessToken: string;
    };

export interface GuestChoiceDto {
  choice: GuestPostPurchaseChoice;
}

export interface ExecuteActionResponseDto {
  action: GuestActionType;
  redirectUrl?: string;
  message?: string;
}

export interface ResendTicketsEmailResponseDto {
  success: boolean;
  resentCount?: number;
}
